module.exports = __webpack_public_path__ + "static/media/12UNCTAD6.cb11f13a.jpg";